var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"src":_vm.url,"frameborder":"0","id":"myiframe","width":"100%","height":"800","allowtransparency":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }